module.exports = __webpack_public_path__ + "img/19.a2f115df.png";